// components/MetaHead.js
import React from 'react';
import { Helmet } from 'react-helmet';
import {
  COMPANY_TITLE,
  COMPANY_META_DESCRIPTION,
  COMPANY_SITE,
  COMPANY_SYMBOL_IMG
} from './consts';

const MetaHead = ({
  title = COMPANY_TITLE,
  description = COMPANY_META_DESCRIPTION,
  image = COMPANY_SYMBOL_IMG,
  url = COMPANY_SITE
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="theme-color" content="#055b84" />
    <meta name="msapplication-navbutton-color" content="#055b84" />
    <meta name="apple-mobile-web-app-status-bar-style" content="#055b84" />

    {/* Open Graph / Facebook */}
    <meta property="og:type" content="website" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:url" content={url} />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />

    <link rel="icon" href="/favicon.ico" />
  </Helmet>
);

export default MetaHead;
